import { defineAsyncComponent } from 'vue'
import { tabOutlineWorld } from 'quasar-extras-svg-icons/tabler-icons-v3'

import type { MainFeatureTwin, FeatureConfig } from 'src/models'

export interface IFrameFeatureTwin extends MainFeatureTwin {
  url: string
}

const featureConfig: FeatureConfig = {
  main: {
    mainComponent: defineAsyncComponent(() => import('./IFrameFeatureMain.vue')),
    fullWidth: true,
    icon: tabOutlineWorld,
    label: 'IFrame'
  }
}

export default featureConfig
